// In-memory page cache so switching tabs shows the last data instantly while it refreshes.
const M = new Map();

export const cached = (k) => M.get(k);

export const remember = (k, v) => {
  if (M.size > 100) M.clear();
  M.set(k, v);
  return v;
};
